import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { SharedCompsService } from 'avn/modules/services/shared-comps.service';

const MILLISECONDS_PER_SECOND = 1000;

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.html',
  styleUrls: ['./snackbar.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackbarComponent implements OnInit {
  public readonly showSnack = signal(false);
  public readonly message = signal('');
  public sendClosedEvent = false;

  public readonly buttonText = signal('Close');
  public routerLink: any;

  public timerSubscription!: ReturnType<typeof setTimeout>;

  public constructor(
    private readonly sharedService: SharedCompsService,
    private readonly router: Router
  ) {}

  public ngOnInit(): void {
    this.sharedService.snackBar.subscribe((data) => {
      this.showSnack.set(false);
      if (!data.message) {
        return;
      }
      if (this.timerSubscription) {
        clearTimeout(this.timerSubscription);
      }
      this.sendClosedEvent = data.sendBack;
      this.message.set(data.message);
      this.buttonText.set(data.buttonText || 'Close');
      this.showSnack.set(true);
      if (data.duration) {
        this.startTimer(data.duration);
      }
      if (data?.routerLink) {
        this.routerLink = data?.routerLink;
      }
    });
  }

  public startTimer(timer: number): void {
    this.timerSubscription = setTimeout(() => {
      this.showSnack.set(false);
    }, timer * MILLISECONDS_PER_SECOND);
  }

  public closeBtn(): void {
    this.showSnack.set(false);
    if (!this.sendClosedEvent) {
      return;
    }
    this.sharedService.snackBarClose.next(true);
    if (this?.routerLink) {
      this.router.navigate([this?.routerLink]);
    }
  }
}
